import React, { useEffect, useState } from "react";
import { useCases, useLead, useNewLead } from "./store";
import moment from "moment";
import { Badge } from "antd";
import ShowCustomer from "modules/dashboards/actionables/ShowCustomer";
import { getQueryParams, statusTagColor } from "modules/utilities/utility";
import SoftBadge from "modules/common/SoftBadge";
import CardDiv from "modules/common/card-div/CardDiv";
import CaseFilter from "./CaseFilter";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import PaginationDiv from "modules/pagination/PaginationDiv";

function AllLeads() {
  const [pageNumber, setPageNumber] = useState(getQueryParams("pageNumber"));
  const url = window.location.href;
  const [showCustomerInFull, setShowCustomerInFull] = useState(false);
  const navigate = useNavigate();
  const [docData, setDocData] = useState();
  const { fetchCases, casesData,casesDataPagination } = useCases();
  const { fetchLead, leadData,leadDataPagination } = useLead();
  const { fetchNewLead, newLeadData ,newLeadDataPagination} = useNewLead();
  const [leadDetails, setLeadDetails] = useState([]);
  const [activeId, setActiveId] = useState();
  const [paginationData, setPaginationData] = useState({});
  const [query, setQuery] = useState();
  const [page, setPage] = useState(1);

  const startDate = moment(new Date()).format("YYYY-MM-DD");
  useEffect(() => {
    setQuery("");
    setPage(1);
    navigate(window.location.pathname + `?startDate=${startDate}`);
  }, [window.location.pathname]);

  useEffect(() => {
    setQuery(url.split("?")[1]);
  }, [url]);

  useEffect(() => {
    if (query) {
      if (url.includes("new")) {
        fetchNewLead(query);
      } else if (url.includes("cases")) {
        fetchCases(query);
      } else {
        fetchLead(query);
      }
      navigate(`?${query}`);
    }
  }, [query]);

  useEffect(() => {
    if (url.includes("new") && newLeadData ) {
      setLeadDetails(newLeadData);
      setPaginationData(newLeadDataPagination);
    } else if (url.includes("cases") && casesData) {
      setLeadDetails(casesData);
      setPaginationData(casesDataPagination);
    } else {
      if (leadData ) {
        setPaginationData(leadDataPagination);
        setLeadDetails(leadData);
      }
    }
  }, [leadData, newLeadData, casesData]);

  useEffect(() => {
    if (leadDetails.length) {
      setActiveId(leadDetails[0].id);
      setDocData(leadDetails[0]);
    }
  }, [leadDetails]);

  useEffect(() => {
    if (query) {
      if (query.split("&").length === 1) {
        setQuery((prevQuery) => prevQuery + `&pageNumber=${page}`);
      } else if (query.split("&").length === 2) {
        setQuery(query.split("&")[0] + `&pageNumber=${page}`);
      } else {
        setQuery((prevQuery) =>
          prevQuery.replace(/&pageNumber=\d+/, `&pageNumber=${page}`)
        );
      }
    }
  }, [page]);
  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between">
          <h3>
            {url.includes("cases")
              ? "All Cases"
              : url.includes("new")
              ? "New Leads"
              : "All Leads"}
          </h3>
          <div className="d-flex gap-3 align-items-center">
            <CaseFilter
              setQuery={setQuery}
              paginationData={paginationData}
              setPage={setPage}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
            />
          </div>
        </div>
      }
      component={
        leadDetails.length && (
          <Row>
            <Col
              md={7}
              className="scrollable-container"
              style={{
                height: "78vh",
                opacity: showCustomerInFull ? 0 : 1,
                width: showCustomerInFull ? "0" : "45%",
                transition: "width 0.3s ease, opacity 0.3s ease",
                overflowY: "hidden",
              }}
            >
              <Row className="border rounded-top py-3 mx-2 table-head fw-bold">
                <Col md={2} className="d-flex gap-2">
                  <span>Name</span>
                </Col>
                <Col md={2} className="text-center">
                  Status
                </Col>
                <Col md={2}>Form Status</Col>
                <Col md={2} className="text-center">
                  Last form fill date
                </Col>
                <Col md={2} className="text-center">
                  Created
                </Col>
                <Col md={2}>Assigned To</Col>
              </Row>
              <div
                style={{ height: "60vh", overflowY: "scroll" }}
                className="scrollable-container"
              >
                {leadDetails.map((lead, index) => {
                  return (
                    <Row
                      className={`border border-top-0 table-row ${
                        index === leadDetails.length - 1 && `rounded-bottom`
                      } py-2 ms-2 me-1`}
                    >
                      <Col md={2} className=" px-2">
                        <div className="d-flex ">
                          <span
                            className="cursor-pointer text-capitalize text-primary fw-bold fs-1"
                            onClick={() => {
                              setActiveId(lead.id);
                              setDocData(lead);
                            }}
                          >
                            {lead?.user?.first_name}
                          </span>
                        </div>
                        <div className="w-100 ">{lead?.user?.phone_number}</div>
                      </Col>
                      <Col md={2} className="text-center">
                        <SoftBadge
                          bg={statusTagColor[lead.status]}
                          key={lead.status}
                        >
                          {lead.status && lead.status.toUpperCase()}
                        </SoftBadge>
                      </Col>
                      <Col md={2} className="text-center">
                        <div className="text-capitalize">
                          {lead.form_status}
                        </div>
                      </Col>
                      <Col md={2} className="text-center">
                        <div>
                          {moment(lead.last_form_fill_date).format(
                            "DD MMM YYYY, hh:mm a"
                          )}
                        </div>
                      </Col>
                      <Col md={2} className="text-center">
                        <div>
                          {moment(lead.created_at).format(
                            "DD MMM YYYY, hh:mm a"
                          )}
                        </div>
                      </Col>
                      <Col md={2} className="text-center">
                        <div>{lead?.assignment?.first_name}</div>
                        <div>
                          <Badge
                            count={lead?.assignment?.level}
                            style={{
                              backgroundColor: "#dcfce7",
                              color: "#166534",
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                  );
                })}
              </div>
              <Row>
                <PaginationDiv
                  newPage={setPage}
                  paginationData={paginationData}
                />
              </Row>
            </Col>
            <Col
              className="p-0 mt-n3"
              style={{
                height: "80vh",
                width: showCustomerInFull ? "100%" : "56%",
                transition: "width 0.3s ease",
                overflow: "hidden",
              }}
            >
              <ShowCustomer
                user={docData}
                caseId={activeId}
                isCaseManagement={"true"}
                showCustomerInFull={showCustomerInFull}
                setShowCustomerInFull={setShowCustomerInFull}
              />
            </Col>
          </Row>
        )
      }
    />
  );
}

export default AllLeads;
